module.exports = __webpack_public_path__ + "static/media/yellowhead-22.6161e39a.jpg";